import React from 'react';
import { connect } from 'react-redux';

import { isLoading } from '@scripts/utilities/redux-helpers.js';
import { DEFAULT_PORTFOLIO_NAME } from '@scripts/utilities/constants.js';

import CMSContent from '../CMSContent/index.jsx';
import Spinner from '../Spinner/index.jsx';

import Dashboard from './Dashboard/index.jsx';
import EditPortfolio from './EditPortfolio/index.jsx';
import Goals from './Goals/index.jsx';

import { fetch as fetchUserPreferences, getUserPreferences, setDashboardAssets, setDashboardBlockchains, setDashboardCategories, setDashboardPortfolio, deleteDashboardPortfolio } from '../../Store/user-preferences.js';
import { getSelectedPortfolio, setSelectedPortfolio, setIsOpenPortfolioCustom } from '../../Store/portfolio.js';
import PortfolioGroupList from './PorfolioGroupList/index.jsx';
import PortfolioBreakdown from "./PortfolioBreakdown/index.jsx";

class Index extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
    this.nameRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetch();
  }
  scrollToPortfolio() {
    setTimeout(() => {
      this.nameRef.current.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  selectPortfolio(selectedPortfolio) {
    this.props.setSelectedPortfolio(selectedPortfolio);
    this.props.setIsOpenPortfolioCustom( !selectedPortfolio.name );
    this.scrollToPortfolio();
  }

  setPortfolio(portfolio, forceClose = false) {
    this.props.setPortfolio(portfolio);
    if(forceClose) {
      this.scrollToPortfolio();
      this.props.setIsOpenPortfolioCustom(false);

    } else if(!portfolio.name) {
      this.props.setIsOpenPortfolioCustom(true);
    }
  }

  deletePortfolio(portfolioId) {
    this.props.deletePortfolio(portfolioId);
  }

  isDisplayPortfoliosBreakdown() {
    return this.props.portfolios.filter(p => p?.assets?.length).length > 1;
  }

  render() {
    let content;
    const { loading, portfolios, selectedPortfolio } = this.props;
    const { name, assets = [], blockchains = [], categories = [], id} = selectedPortfolio || {};
    if (loading) {
      content = (
        <div className="my-3">
          <Spinner />
        </div>
      );
    } else {

      content = (
          <React.Fragment>
            <Goals />
            
            <PortfolioGroupList selectedPortfolioId={id} portfolios={portfolios} setPortfolio={this.setPortfolio.bind(this)} selectPortfolio={this.selectPortfolio.bind(this)}/>

            {
                this.isDisplayPortfoliosBreakdown() && <div className="cs-dashboard__portfolio-breakdown">
                <CMSContent variants="template">
                  <PortfolioBreakdown
                      key={`portfolio-breakdown-totals`}
                      portfolios={portfolios}
                  />
                </CMSContent>
              </div>
            }
            <div style={{display: id ? 'block' : 'none'}}>
              <h1 ref={this.nameRef}>{name || DEFAULT_PORTFOLIO_NAME}</h1>
              {selectedPortfolio && <EditPortfolio
                  key={id}
                  selectedPortfolio={selectedPortfolio}
                  deletePortfolio={this.deletePortfolio.bind(this)}
                  savePortfolio={this.setPortfolio.bind(this)}
              />
              }
            </div>
            {
              assets?.length ?
                  <Dashboard name={name || DEFAULT_PORTFOLIO_NAME} assets={assets} blockchains={blockchains} categories={categories} portfolioId={id}/>
                  : undefined
            }
          </React.Fragment>
      );
    }

    return (
        <CMSContent variants="template">
          {content}
        </CMSContent>
    );
  }
}


const mapStateToProps = function (state) {
  const userPreferences = getUserPreferences(state);
  let selectedPortfolio = getSelectedPortfolio(state);

  // On page load, always view the first portfolio
  if(!selectedPortfolio?.id && userPreferences.dashboard?.portfolios?.length) {
    selectedPortfolio = userPreferences.dashboard?.portfolios?.[0] || {};
    setSelectedPortfolio(selectedPortfolio);
  }
  const loading = isLoading(userPreferences.status);
  return {  
    assets: userPreferences.dashboard.assets,
    blockchains: userPreferences.dashboard.blockchains,
    categories: userPreferences.dashboard.categories,
    portfolios: userPreferences.dashboard.portfolios,
    selectedPortfolio,
    loading: loading
  };
};

const mapDispatchToProps = function(dispatch) {
  return {
    fetch: function() {
      dispatch(fetchUserPreferences());
    },
    setAssets: function(value) {
      dispatch(setDashboardAssets(value));
    },
    setBlockchains: function(value) {
      dispatch(setDashboardBlockchains(value));
    },
    setCategories: function(value) {
      dispatch(setDashboardCategories(value));
    },
    setPortfolio: function(value) {
      dispatch(setDashboardPortfolio(value));
    },
    deletePortfolio: function(value) {
      dispatch(deleteDashboardPortfolio(value));
    },
    setSelectedPortfolio: function(value) {
      dispatch(setSelectedPortfolio(value));
    },
    setIsOpenPortfolioCustom: function(value) {
      dispatch(setIsOpenPortfolioCustom(value));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Index);

